module.exports = __webpack_public_path__ + "img/icon-excel-duotone.6bb84a62.svg";